import axios from 'axios';
import authService from './auth';
import AlertService from '../utils/alert';
import router from '../router';

// Variable para controlar si los interceptores ya han sido configurados
let interceptorsSetup = false;

// Configurar interceptor para añadir token de autenticación a todas las solicitudes
const setupInterceptors = () => {
  // Evitar configurar los interceptores más de una vez
  if (interceptorsSetup) {
    console.log('Interceptores ya configurados, evitando duplicación');
    return;
  }
  
  interceptorsSetup = true;
  axios.interceptors.request.use(
    (config) => {
      const token = authService.getToken();
      if (token) {
        console.log('Token encontrado:', token);
        // Añadir el token al encabezado de autorización
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Interceptor para manejar errores de respuesta (401, 403, etc.)
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        console.log('Sesión expirada o token inválido');
        
        // Mostrar alerta al usuario
        AlertService.warning(
          'Tu sesión ha expirado o no tienes autorización para acceder a este recurso.',
          'Sesión expirada',
          { timer: 3000 }
        ).then(() => {
          // Limpiar datos de sesión
          localStorage.removeItem('user_session');
          localStorage.removeItem('user_token');
          localStorage.removeItem('user_menu');
          
          // Redirigir a la página de login usando el router de Vue
          router.push('/login')
        });
      }
      return Promise.reject(error);
    }
  );
};

export default setupInterceptors;
